import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const selectCurrenciesExchangeState = createSelector(
  (state: RootState) => state.rate.currencies,
  (clients) => clients
);

export const selectCurrenciesExchangeData = createSelector(
  selectCurrenciesExchangeState,
  (clientStatus) => clientStatus.data
);
